import { Col, DatePicker, Button, Form, FormInstance, FormProps, Row, Divider } from "antd";
import RateioFluxoRelatorio from "../../../../../../../Models/Financeiro/Titulo/Rateio/RateioFluxoRelatorio";
import { forwardRef, useRef, useState } from "react";
import { BooleanProps } from "../../../../../../../utility-types";
import RateioFluxoRelatorioCollapseBasic from "./RateioFluxoRelatorioTable";
import { useRateioFluxoRelatorioListar } from "../../../../../../../Services/Financeiro/Titulo/RateioService";
import PessoaSelectComTipo from "../../../../../Pessoa/PessoaSelect";
import dayjs from 'dayjs';
import Utilitario from "../../../../../../../Utils/Utilitario";
import TipoConsultaDataSelect from "../../../TipoConsultaData/TipoConsultaDataSelect";
import { EnumTipoConsultaData } from "../../../../../../../Models/Financeiro/Titulo/Titulo";
import ComponentePrint, { IComponentePrintRef } from "../../../../../../Base/Baixar/ComponentePrint";
import InputRangePicker from "@/Components/Base/Input/InputRangePicker";

export type RateioFluxoRelatorioConsultaScreenFormType = {
    rateioFluxoRelatorio?:RateioFluxoRelatorio;
    intervalo?:[dayjs.Dayjs, dayjs.Dayjs];
}
export interface IRateioFluxoRelatorioConsultaScreenProps extends FormProps<RateioFluxoRelatorioConsultaScreenFormType> {
    fieldsDisabled?:BooleanProps<RateioFluxoRelatorioConsultaScreenFormType>;
}
export interface IRateioFluxoRelatorioConsultaScreenRef extends FormInstance<RateioFluxoRelatorioConsultaScreenFormType> {

};
const RateioFluxoRelatorioConsultaScreen = forwardRef<IRateioFluxoRelatorioConsultaScreenRef, IRateioFluxoRelatorioConsultaScreenProps>(function RateioFluxoRelatorioConsultaScreen (
    {
        form : formParam,
        disabled,
        component,
        layout,
        autoComplete,
        fieldsDisabled,
        ...props
    }, 
    ref
) {
    const refPrint = useRef<IComponentePrintRef|null>(null);
    const [ consultar, setConsultar ] = useState(false);
    const [newForm] = Form.useForm<RateioFluxoRelatorioConsultaScreenFormType>();
    const form = formParam ?? newForm;
    const dadosConsulta = Form.useWatch([], form);
    const dataAtual = new Date();

    const {
        data,
        isLoading
    } = useRateioFluxoRelatorioListar({
        rateioFluxoRelatorioParam : {
            ...(dadosConsulta?.rateioFluxoRelatorio ?? {}),
            dataInical : dadosConsulta?.intervalo?.[0]?.toDate(),
            dataFinal : dadosConsulta?.intervalo?.[1]?.toDate()
        } as RateioFluxoRelatorio,
        enabled: consultar,
        onFinish : () => setConsultar(false)
    });

    return <ComponentePrint ref={refPrint} titulo="Relatorio_Plano_Contas">
        <Form<RateioFluxoRelatorioConsultaScreenFormType>
            ref={ref}
            form={form}
            disabled={disabled}
            component={component ?? "div"}
            layout={layout ?? "vertical"}
            autoComplete={autoComplete ?? "off"}
            initialValues={{
                rateioFluxoRelatorio : {
                    tipoConsulta : EnumTipoConsultaData.DataVencimento
                } as RateioFluxoRelatorio,
                intervalo : [ dayjs(new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1)), dayjs(new Date()) ]
            } as RateioFluxoRelatorioConsultaScreenFormType}
            onFinish={() => {
                setConsultar(true);
            }}
            {...props}
        >
            <Row gutter={8} wrap>
                <Col xs={24} sm={12} md={5} lg={4} xl={4} xxl={4}>
                    <Form.Item label="Tipo consulta" rules={[{ required : true }]} name={["rateioFluxoRelatorio", "tipoConsulta"]}>
                        <TipoConsultaDataSelect />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={7} lg={6} xl={6} xxl={6}>
                    <Form.Item label="Intervalo" name={"intervalo"} rules={[
                        {
                            required : true
                        },
                        {
                            validator(rule, value:[dayjs.Dayjs, dayjs.Dayjs], callback) {
                                if ((value?.length ?? 0) === 2 && Utilitario.diferancaEntreDatas(value[0].toDate(), value[1].toDate()) > 61)
                                    return Promise.reject(new Error("Por favor, informe um intervalo de no máximo 62 dias."));
                                    
                                return Promise.resolve();
                            }
                        }
                    ]}>
                        <InputRangePicker />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={14} xl={14} xxl={14}>
                    <PessoaSelectComTipo<RateioFluxoRelatorioConsultaScreenFormType>
                        tiposPessoaValidos={undefined}
                        tiposPessoaInValidos={undefined}
                        names={{
                            tipo: ["rateioFluxoRelatorio", "pessoa", "tipo"],
                            "*": ["rateioFluxoRelatorio", "codPessoa"],
                        }}
                        rules={{
                            tipo: [{ required: true }],
                            "*": [{ required: true, message: "Por favor, selecione uma pessoa" }],
                        }}
                    />
                </Col>
            </Row>

            <Row gutter={8} wrap className="nao-imprimir">
                <Col xs={"auto"}>
                    <Button type="primary" onClick={() => form.submit()}>
                        Listar
                    </Button>
                </Col>
                <Col xs={"auto"}>
                    <Button type="dashed" onClick={() => refPrint.current?.imprimir()}>
                        Exportar
                    </Button>
                </Col>
            </Row>

            <Divider>Registros</Divider>

            <RateioFluxoRelatorioCollapseBasic loading={isLoading} dataSource={data} />
        </Form>
    </ComponentePrint>;
});

export default RateioFluxoRelatorioConsultaScreen;